module.exports = __webpack_public_path__ + "static/media/SL 13.b5a86f8d.mp3";